<script>
import NotAuthHeader from "./header/NotAuthHeader.vue";
import Footer from "./footer/Footer.vue";
import FeedbackModal from "@/components/Custom/FeedbackModal.vue";

export default {
  name: "NotAuthLayout",
  components: { NotAuthHeader, FeedbackModal, Footer }
};
</script>

<template>
  <div class="auth-layout">
    <NotAuthHeader />
    <div class="auth-layout__box">
      <router-view />
    </div>
    <Footer class="auth-layout__footer" />
    <FeedbackModal />
  </div>
</template>

<style lang="scss" scoped>
@import "@v2/app/styles/media";

.auth-layout {
  background: url("../../../../../../public/static/images/auth-layout-bg.svg")
    no-repeat right bottom 60px;
  background-size: cover;
  min-height: calc(var(--vh, 1vh) * 100);

  display: flex;
  flex-direction: column;

  &__box {
    margin: 48px auto 128px auto;

    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.25);
    background-color: #ffffff;

    align-self: center;

    @include respond-down(md) {
      margin: 25px auto 32px auto;
    }
  }

  &__footer {
    margin-top: auto;

    align-self: center;
    width: 100%;
  }
}
</style>
